import { yupResolver } from "@hookform/resolvers/yup";
import { useMediaQuery } from "@material-ui/core";
import { Box, Stack, TextField, Theme, useTheme } from "@mui/material";
import { useRequest } from "ahooks";
import Button from "components/Overrides/Button/Button";
import { ROUTES } from "helpers/routes";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { serviceUpdateVisitor } from "services/api/visitor";
import urlcat from "urlcat";
import * as yup from "yup";

const schema = yup.object().shape({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("First name is required"),
  email: yup.string().required("Email is required").email("Email is invalid"),
  position: yup.string().required("Position is required"),
  companyName: yup.string().required("Company name is required"),
  oldCompanyName: yup.string().required("Old company name is required"),
});

const FormUpdateVisitor = () => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm<any>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { loading, run: updateVisitor } = useRequest(serviceUpdateVisitor, {
    manual: true,
    onSuccess: ({ success = false }) => {
      if (success) {
        navigate(urlcat("", ROUTES.THANK_YOU));
      }
    },
  });

  const onSubmit = async (data: Visitor) => {
    updateVisitor(data);
  };

  const onError = (errors: any) => {
    console.log(errors);
  };

  return (
    <Stack spacing={4} alignItems="center">
      <Stack gap={2} direction="row" flexWrap="wrap" style={{ width: "100%" }}>
        <Stack
          direction="column"
          spacing={4}
          style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}
        >
          <Controller
            name="firstName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="First Name"
                margin="normal"
                error={!!errors.firstName}
                helperText={errors.firstName?.message as string}
              />
            )}
          />
          <Controller
            name="lastName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Last Name"
                margin="normal"
                error={!!errors.lastName}
                helperText={errors.lastName?.message as string}
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                type="email"
                label="Your work email"
                margin="normal"
                error={!!errors.email}
                helperText={errors.email?.message as string}
              />
            )}
          />
        </Stack>
        <Stack
          direction="column"
          spacing={4}
          style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}
        >
          <Controller
            name="position"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Position"
                margin="normal"
                error={!!errors.position}
                helperText={errors.position?.message as string}
              />
            )}
          />
          <Controller
            name="oldCompanyName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Previous Company Name"
                margin="normal"
                error={!!errors.oldCompanyName}
                helperText={errors.oldCompanyName?.message as string}
              />
            )}
          />
          <Controller
            name="companyName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Current Company Name"
                margin="normal"
                error={!!errors.companyName}
                helperText={errors.companyName?.message as string}
              />
            )}
          />
        </Stack>
      </Stack>

      <Box>
        <Button
          loading={loading}
          variant="contained"
          disabled={!isValid || !isDirty || loading}
          onClick={handleSubmit(onSubmit, onError)}
          style={{ paddingInline: theme.spacing(8) }}
        >
          Done
        </Button>
      </Box>
    </Stack>
  );
};

export default FormUpdateVisitor;
